module.exports = __webpack_public_path__ + "static/coworking5-6710cd64b85f6f7f753133ab7b7c2ce4.jpg";